import { MeasurementUnit } from '@ml/services/types/service';

export class TaskInformation {
  name: string;
  description?: string;
  driverDescription?: string;
  service: number;
  order: number;
  customer?: number;

  diameter?: number;
  measurementUnits?: MeasurementUnit[];
  hourlyRate?: number;
}
